<template>
  <div class="navbar navbar-default navbar-fixed-top" role="navigation">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NavigationBar'
};
</script>

<style lang="scss" src="./navigation-bar.scss"></style>
